export default __webpack_public_path__ + "static/media/redCircle.1de3e0ba.svg";